export const SIDEBAR_DESKTOP_EXPANDED_WIDTH = 279
export const SIDEBAR_DESKTOP_COLLAPSED_WIDTH = 64
export const SIDEBAR_MOBILE_WIDTH = 280

export const SIDEBAR_CTA_HEIGHT = 40
export const SIDEBAR_ICON_SIZE = 18

export const SIDEBAR_NAV_ICON_HOVER =
  'hover:bg-sidebar-foreground/5 hover:text-sidebar-foreground'

export const SIDEBAR_COLLAPSED_NAV_ICON_HOVER =
  `text-sidebar-foreground/72 ${SIDEBAR_NAV_ICON_HOVER}`

export const SIDEBAR_EXPANDED_NAV_ICON_HOVER =
  `text-sidebar-foreground/82 ${SIDEBAR_NAV_ICON_HOVER}`
